/** @jsx jsx */
import { css, jsx, keyframes } from "@emotion/core"

export function Spinner({ size }: { size: number }) {
  const load = keyframes`
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  `
  return (
    <div
      css={css`
        &,
        &:after {
          border-radius: 50%;
          width: ${size}px;
          height: ${size}px;
        }
        & {
          font-size: 10px;
          position: relative;
          text-indent: -9999em;
          border-top: ${(size / 10) * 1.5}px solid rgba(255, 255, 255, 0.2);
          border-right: ${(size / 10) * 1.5}px solid rgba(255, 255, 255, 0.2);
          border-bottom: ${(size / 10) * 1.5}px solid rgba(255, 255, 255, 0.2);
          border-left: ${(size / 10) * 1.5}px solid #ffffff;
          transform: translateZ(0);
          animation: ${load} 1.1s infinite linear;
        }
      `}
    />
  )
}
